import { VueMasonryPlugin } from 'vue-masonry';
import { Platform } from 'quasar';

export default ({ Vue }) => {
  // Only needed for desktop
  if (Platform.is.desktop) {
    Vue.use(VueMasonryPlugin);
  }
  else {
    // Add an empty directive to remove warnings
    Vue.directive('masonry', {});
  }
};
